import api from '../../helpers/services/f2f/api';
import { createNotification } from 'react-redux-notify';
import { put, takeLatest, all } from 'redux-saga/effects';

import {
  CREATE_PACKAGES,
  DELETED_PACKAGES,
  TOTAL_GET_F2F_PACKAGES,
  FACE_2FACE_PACKGE_FOR_USER,
  FACE2FACE_EDIT_PACKAGE_START,
  FACE_TO_FACE_PACKAGE_DISCOUNT,
} from '../actions/ActionConstant';
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from '../../components/helper/NotificationMessage';
import {
  createf2fpackages,
  createf2filure,
  face2facepackages,
  editF2FPackageSuccess,
  getf2fdiscountSuccess,
  editF2FPackageFailure,
  getf2fdiscountFailure,
  fetchf2fpackagessuccess,
  fetchf2fpackagesfailure,
  fetchf2fdeletepackagessuccess,
  fetchf2fdeletepackagesfailure,
  f2fgte_user_to_performer_packgesSuccess,
  f2fgte_user_to_performer_packgesFailure,
} from '../actions/Face2FaceAction';

function* getFace2Facepackages() {
  try {
    const response = yield api.getMethod('face2face-package/get-package');
    if (response.data.success) {
      yield put(fetchf2fpackagessuccess(response.data));
    } else {
      yield put(fetchf2fpackagesfailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchf2fpackagesfailure(error));
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error[0] || error.message,
    );
    yield put(createNotification(notificationMessage));
  }
}

function* getFace2FacepackagesDiscount() {
  try {
    const response = yield api.getMethod('face2face-package/get-package-discount');
    if (response.data.success) {
      yield put(getf2fdiscountSuccess(response.data));
    } else {
      yield put(getf2fdiscountFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(getf2fdiscountFailure(error));
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error[0] || error.message,
    );
    yield put(createNotification(notificationMessage));
  }
}

function* editFace2FacePackages(action) {
  try {
    const response = yield api.postMethod(
      `face2face-package/update-package/${action?.data?.id}`,
      action?.data,
    );
    if (response.data.success) {
      yield put(editF2FPackageSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(response.data.message);
      yield put(createNotification(notificationMessage));
      yield put(face2facepackages())
    } else {
      yield put(editF2FPackageFailure(response.data.message));
      const notificationMessage = getErrorNotificationMessage(response.data.message[0].message);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    let notificationMessage;
    yield put(editF2FPackageFailure(error));
    if (error.response) {
      notificationMessage = getErrorNotificationMessage(
        error?.response?.data?.error[0]?.message || error?.response?.data?.error[0],
      );
    } else {
      notificationMessage = getErrorNotificationMessage(
        error.message || error.response.data.error[0],
      );
    }
    yield put(createNotification(notificationMessage));
  }
}

function* deleteFace2FacePackages(action) {
  try {
    const response = yield api.deleteMethod(`face2face-package/del-pacakge/${action?.data}`);

    if (response.data.success) {
      yield put(fetchf2fdeletepackagessuccess(response.data));
      yield put(face2facepackages({}));
      const notificationMessage = getSuccessNotificationMessage(response.data.message);
      yield put(createNotification(notificationMessage));
    } else {
      yield put(fetchf2fdeletepackagesfailure(response.data.message));
      const notificationMessage = getErrorNotificationMessage(response.data.message);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchf2fdeletepackagesfailure(error));
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error[0] || error.message,
    );
    yield put(createNotification(notificationMessage));
  }
}

function* createPackage(action) {
  try {
    const response = yield api.postMethod(`face2face-package/create-package`, action?.data);

    if (response.data.success) {
      yield put(createf2fpackages(response.data));
      const notificationMessage = getSuccessNotificationMessage(response.data.message);
      yield put(createNotification(notificationMessage));
    } else {
      yield put(createf2filure(response.data.message));
      const notificationMessage = getErrorNotificationMessage(response.data.message[0].message);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(createf2filure(error.response || error.message));
    let notificationMessage;
    if (error?.response?.data?.error[0]?.message) {
      notificationMessage = getErrorNotificationMessage(error?.response?.data?.error[0]?.message);
    } else {
      notificationMessage = getErrorNotificationMessage(error.response.data.error || error.message);
    }
    yield put(createNotification(notificationMessage));
  }
}

function* getFace2Facepackages_for_user(action) {
  try {
    const response = yield api.getMethod(
      `face2face-package/get-performer-to-user/${action?.data} `,
    );
    if (response.data.success) {
      yield put(f2fgte_user_to_performer_packgesSuccess(response.data));
    } else {
      yield put(f2fgte_user_to_performer_packgesFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(f2fgte_user_to_performer_packgesFailure(error));
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error[0] || error.message,
    );

    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(CREATE_PACKAGES, createPackage)]);
  yield all([yield takeLatest(FACE_TO_FACE_PACKAGE_DISCOUNT, getFace2FacepackagesDiscount)]);
  yield all([yield takeLatest(TOTAL_GET_F2F_PACKAGES, getFace2Facepackages)]);
  yield all([yield takeLatest(FACE2FACE_EDIT_PACKAGE_START, editFace2FacePackages)]);
  yield all([yield takeLatest(DELETED_PACKAGES, deleteFace2FacePackages)]);
  yield all([yield takeLatest(FACE_2FACE_PACKGE_FOR_USER, getFace2Facepackages_for_user)]);
}

